/* tslint:disable */
/* eslint-disable */
import { BaseModel } from '@/core/models/base.model';
import { FormGroup, FormControl, FormArray, AbstractControl, Validators } from '@angular/forms';

// All imports for FormGroups..

export interface IValidationFailureDisplayModel {
  errorCode?: null | string;
  errorMessage?: null | string;
  propertyName?: null | string;
}
export class ValidationFailureDisplayModel extends BaseModel implements IValidationFailureDisplayModel {
  errorCode?: null | string;
  errorMessage?: null | string;
  propertyName?: null | string;
}
class BaseValidationFailureDisplayModelFormGroup extends FormGroup {
  private static _instance: ValidationFailureDisplayModelFormGroup;
  
  public static get Instance(): ValidationFailureDisplayModelFormGroup {
    this._instance = new ValidationFailureDisplayModelFormGroup({
      errorCode: new FormControl(null),
      errorMessage: new FormControl(null),
      propertyName: new FormControl(null),
    });

    return this._instance;
  }
}


export class ValidationFailureDisplayModelFormGroup extends BaseValidationFailureDisplayModelFormGroup {
  public get ErrorCode(): FormControl {
    return this.controls["errorCode"] as FormControl;
  }
  public get ErrorMessage(): FormControl {
    return this.controls["errorMessage"] as FormControl;
  }
  public get PropertyName(): FormControl {
    return this.controls["propertyName"] as FormControl;
  }
  

}

export module ValidationFailureDisplayModelForm
  {
    export class FormFields
    {
      static _errorCode: string = "errorCode";
      static _errorMessage: string = "errorMessage";
      static _propertyName: string = "propertyName";
    }
  }

